import { Dialog } from "@mui/material";
import React from "react";
import {
  InvoiceDesignScope,
  InvoiceDialogCloseButton,
  invoiceDialogPaperSx,
} from "../Invoicing/InvoiceDesignSystem";
import { prospectDesignFontFamily, prospectDialogCloseIconOptions, prospectDialogSx } from "./prospectDesign";

export type ProspectResultDialogProps = Readonly<{
  open: boolean;
  onClose: () => void;
  kind: "saved" | "matched";
  companyName: string;
  memberName?: string;
}>;

export const ProspectResultDialog = ({
  open,
  onClose,
  kind,
  companyName,
  memberName,
}: ProspectResultDialogProps): React.ReactElement => (
  <InvoiceDesignScope fontFamily={prospectDesignFontFamily}>
    <Dialog
      aria-label={kind === "saved" ? "Prospect Saved" : "Prospect Matched"}
      aria-describedby="prospect-result-message"
      maxWidth={false}
      onClose={onClose}
      open={open}
      PaperProps={{ sx: invoiceDialogPaperSx({ maxWidth: 440 }) }}
      sx={prospectDialogSx}
    >
      <div className="relative flex flex-col items-center px-7 py-[30px]">
        <InvoiceDialogCloseButton ariaLabel="Close" onClick={onClose} outlinedIcon={prospectDialogCloseIconOptions} hoverBackgroundColor="#F21B1B" />
        <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-[#12B981]">
          <svg
            aria-hidden="true"
            width="37"
            height="37"
            viewBox="0 0 48 48"
            fill="none"
            stroke="white"
            strokeWidth="2.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="24" cy="24" r="17" />
            <path d="m16 24.5 5.5 5.5L32 19" />
          </svg>
        </div>
        <p
          id="prospect-result-message"
          className="mt-[18px] w-full break-words text-center text-[14px] font-normal leading-[1.55] text-[#0A0A0A]"
        >
          The prospect {kind === "saved" ? <span className="font-semibold">{companyName}</span> : companyName}
          {kind === "saved" ? (
            " has been saved successfully and is now visible in Manage Prospects."
          ) : (
            <>
              {" has been matched to the member "}
              {memberName}
              {" and is now marked as Converted to Member."}
            </>
          )}
        </p>
      </div>
    </Dialog>
  </InvoiceDesignScope>
);

export default ProspectResultDialog;
